// extracted by mini-css-extract-plugin
export default {"customTooltip":"Cost_customTooltip__EHRZr","tooltipLabel":"Cost_tooltipLabel__5oc6L","tooltipValue":"Cost_tooltipValue__nLlyQ"};